import { Pdf } from '@fagmobler/sanity';

export const ProductPagePdfs = ({ pdfs }: { pdfs: Pdf[] }) => {
  return (
    <div className="grid grid-cols-4 gap-5 relative print:hidden">
      {pdfs.map((pdf) => {
        return (
          <div key={pdf._id} className="aspect-square bg-neutral-40 relative">
            <iframe
              src={`${pdf.ipaperIframeUrl}-/embedded/flat/singlepage/1/`}
              className="w-full h-full"
            />
            <h2 className="hd-lg text-center p-5">
              <a href={pdf.ipaperIframeUrl}>{pdf.title}</a>
            </h2>
          </div>
        );
      })}
    </div>
  );
};
